/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import * as stylex from '@stylexjs/stylex';
import { createContext, type ForwardedRef, forwardRef, type ReactElement } from 'react';
import { Calendar as CalendarCore, type CalendarProps as CalendarCoreProps, type ContextValue, type DateValue, DEFAULT_SLOT, Provider, useContextProps } from 'react-aria-components';
import { ViewContext } from '../view/view.component';

interface CalendarProps<T extends DateValue> extends Omit<CalendarCoreProps<T>, 'style' | 'className'> {
  style?: stylex.StyleXStyles;
}

const CalendarContext = createContext<ContextValue<CalendarProps<DateValue>, HTMLDivElement>>({});

const Calendar = forwardRef((props: CalendarProps<DateValue>, ref: ForwardedRef<HTMLDivElement>) => {
  [props, ref] = useContextProps(props, ref, CalendarContext);

  const { style, children, ...coreProps } = props;

  return (
    <Provider
      values={[[ViewContext, {
        slots: {
          [DEFAULT_SLOT]: {},
          [CALENDAR_SLOTS.CALENDARS_VIEW]: {
            style: calendarsViewStyles.base
          }
        }
      }]]}>
      <CalendarCore ref={ref} {...stylex.props(styles.base, style)} {...coreProps}>
        {children}
      </CalendarCore>
    </Provider>
  );
}) as <T extends DateValue>(props: CalendarProps<T> & { ref?: ForwardedRef<HTMLDivElement> }) => ReactElement;

const styles = stylex.create({
  base: {
    maxWidth: '100%',
    width: 'fit-content',
  },
});

const calendarsViewStyles = stylex.create({
  base: {
    gap: 24,
    alignItems: 'flex-start',
    alignSelf: 'stretch',
    display: 'flex',
  }
});

const CALENDAR_SLOTS = {
  PREVIOUS_BUTTON: 'previous',
  NEXT_BUTTON: 'next',
  CALENDARS_VIEW: 'calendars-view'
};

export { Calendar, CALENDAR_SLOTS, CalendarContext, type CalendarProps };

